import { IconFromSet, IconPicker, IconValue } from "@gettactic/components";
import { TacticIconsDictionary } from "@gettactic/components/src/icons/tactic-icons/dictionary";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@gettactic/components/src/primitives/Popover";
import { X } from "lucide-react";
import React from "react";
import { IconButton } from "../../../../ui/IconButton";

export interface SpotStateIconControlProps {
  label: string;
  value?: IconValue;
  onChange: (icon: IconValue | undefined) => void;
}

/** Row control for one availability-state icon: shows the current icon,
 *  opens the shared IconPicker to change it, and clears it with the X. */
export const SpotStateIconControl: React.FC<SpotStateIconControlProps> = ({
  label,
  value,
  onChange
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="flex min-h-7 items-center gap-2">
      <span className="flex-1 text-neutral-600 text-xs">{label}</span>
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="flex h-7 min-w-14 items-center justify-center gap-1 rounded-md border border-neutral-300 px-2 text-xs hover:bg-neutral-100"
          >
            {value ? (
              <IconFromSet icon={value} size={4} />
            ) : (
              <span className="text-neutral-400">None</span>
            )}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-[550px] bg-background-primary p-0">
          {/* Built-in sets only (tactic/mdi/lucide) — state icons are stored
              as IconValue and rendered via IconFromSet, which can't resolve
              API-uploaded icons (those need a URL). */}
          <IconPicker
            initialIconSet="tactic"
            customSets={TacticIconsDictionary}
            onSelect={(icon) => {
              onChange(icon);
              setIsOpen(false);
            }}
          />
        </PopoverContent>
      </Popover>
      {value ? (
        <IconButton
          size="sm"
          label={`Clear ${label}`}
          onClick={() => onChange(undefined)}
        >
          <X size={13} />
        </IconButton>
      ) : null}
    </div>
  );
};
